import { SimpleMappedStorePresentation } from "@core/store/mappedStorePresentation";
import { SimpleStore } from "@core/store/store";

import { UserApi } from "@domain/user/userApi";
import { Livecourse, LiveCourseParticipant } from "./livecourse";
import { LivecourseApi } from "./livecourseApi";

export class LivecourseService {
	livecourseStore = new SimpleStore((id) => this.livecourseApi.get(id));
	profilesStore = new SimpleStore((id) => this.userApi.getProfile(id));
	userLivecoursesStore = new SimpleMappedStorePresentation(this.livecourseStore, (shareroomId) =>
		this.livecourseApi.List(shareroomId, "byGroup")
	);
	participantsStore = new SimpleMappedStorePresentation(this.profilesStore, (id, page) =>
		this.livecourseApi.getParticipants(id, page)
	);

	organizationLivecoursesStore = new SimpleMappedStorePresentation(this.livecourseStore, (organizationId) =>
		this.livecourseApi.List(organizationId, "byOrganization")
	);

	getInfos = new SimpleStore((id) => this.livecourseApi.get(id));

	confirmParticipation = new SimpleStore((id) => this.livecourseApi.confirm(id));

	constructor(
		private readonly livecourseApi: LivecourseApi,
		private readonly userApi: UserApi
	) {}

	async confirm(id: string): Promise<LiveCourseParticipant> {
		return await this.livecourseApi.confirm(id);
	}

	async delete(id: string): Promise<void> {
		await this.livecourseApi.delete(id);
		this.livecourseStore.remove(id);
	}

	async saveLivecourse(liveCourse: Livecourse): Promise<Livecourse> {
		console.log("liveCourse", liveCourse);
		return liveCourse.id ? this.livecourseApi.save(liveCourse) : this.livecourseApi.create(liveCourse);
	}

	async getLiveCourse(livecourseId: string): Promise<Livecourse> {
		return this.livecourseApi.get(livecourseId);
	}
}
